import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogComponent } from "./../../common/DialogComponent";
import IDFProtectionPlanBillingInfo from "../../Dialogs/protectionPlan/IDFProtectionPlanBillingInfo";
import IDFProtectionPlanTermsAndCondition from "../../Dialogs/protectionPlan/IDFProtectionPlanTermsAndCondition";
import * as services from "../../../store/service";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../store";
import { IPackage } from "../../../store/protectionPlanService/idf/types";
import { Notification } from "../../common/Notification";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    closeDialog: any;
    dialogId: string;
    packageIndex: number;
    closeUpgradeAndOpenCompletionDialog: any;
}

const IDFProtectionPlanUpgradePackage: React.FunctionComponent<IProps> = (props) => {
    const [showBillingInfoDialog, setShowBillingInfoDialog] = useState(false);
    const [tncDialog, setTncDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const packageList = useSelector((state: ApplicationState) => {
        if (state.protectionPlanIdfState && state.protectionPlanIdfState.protectionPlanData) {
            return state.protectionPlanIdfState.protectionPlanData.packageList;
        }
    });

    const [creditCard, setCreditCard] = useState({
        cardNumber: "",
        nameOnCard: "",
        billingZip: "",
        cardType: "",
        countryId: 0,
        expDateMo: "",
        expDateYr: "",
        expirationDate: "",
        securityCode: "",
    });

    const selectedPackage = (packageList && packageList.length >= props.packageIndex ? packageList[props.packageIndex] : null) as IPackage;

    const handleBillingCloseDialog = (value: string): any => {
        if (value === "show") {
            setShowBillingInfoDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowBillingInfoDialog(false);
            loadPaymentInfoData();
        }
    };
    const showBillingInformation = (event: any) => {
        handleBillingCloseDialog("show");
    };

    const handleTncDialog = (value: string): any => {
        if (value === "show") {
            setTncDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        }
    };

    const { register, errors, reset, formState, handleSubmit } = useForm({
        mode: "onSubmit",
    });

    const onSubmit = (data: any) => {
        setLoading(true);
        if (selectedPackage?.ActionButtonText?.toUpperCase() === "CANCEL") {
            services.CancelIDFPackage().then((data) => {
                setLoading(false);
                data = JSON.parse(data);
                if (data["status-code"] == 200) {
                    let cancellationDate = data["cancellation-date"];
                    props.closeUpgradeAndOpenCompletionDialog(cancellationDate);
                } else {
                    showErrorNotification(data.errors);
                }
            });
        } else {
            services.UpgradeIDFPackage("" + selectedPackage?.id).then((data) => {
                setLoading(false);
                if (data["status-code"] == 200) {
                    let nextBillingDate = "";
                    props.closeUpgradeAndOpenCompletionDialog(nextBillingDate);
                } else {
                    showErrorNotification(data.errors);
                }
            });
        }
    };

    const showErrorNotification = (errors: any[]) => {
        if (errors) {
            Notification({
                type: "error",
                title: dialogTitle(),
                message: errors[0],
                duration: 5,
            });
        } else {
            Notification({
                type: "error",
                title: dialogTitle(),
                message: "Could not save information. Please try again later.",
                duration: 5,
            });
        }
    };

    const dialogTitle = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return "Cancel " + selectedPackage.name + " Plan";
        } else if (selectedPackage?.ActionButtonText?.toLowerCase() === "upgrade") {
            return "Upgrade to " + selectedPackage.name + " Plan";
        } else {
            return "";
        }
    };

    const submitButtonLabel = () => {
        if (selectedPackage?.ActionButtonText?.toLowerCase() === "cancel") {
            return "Cancel Plan";
        } else {
            return selectedPackage?.ActionButtonText;
        }
    };

    const getBillingAmountLabel = () => {
        return "Total balance today";
    };

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    useEffect(() => {
        loadPaymentInfoData();
    }, []);

    const loadPaymentInfoData = () => {
        services.GetPaymentDetail().then((data) => {
            setCreditCard(data.creditCard);
        });
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>{dialogTitle()}</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} id="protection-plan-upgrade-form-container">
                <div className={"dialog-body " + (loading ? "loading" : "")}>
                    <div className="form-row">
                        <h3 className="content-sub-title">Your Cart Summary</h3>
                    </div>
                    <div className="line-divider margin-vertical-xs"></div>

                    <div className="form-row data-grid has-lines row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label font-weight-bold" id="label-selected-plan">
                                        <strong>Your Plan</strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value">
                                        {selectedPackage?.name}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className={"form-row data-grid row-height-sm " + selectedPackage?.ActionButtonText?.toLowerCase() !== "cancel" ? "has-lines" : ""}>
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-payment-info">
                                        <p>
                                            <strong>Payment Information</strong>
                                        </p>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value">
                                        <div className="row between-xs">
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                {creditCard?.cardNumber ? (
                                                    <p>
                                                        {creditCard?.nameOnCard && (
                                                            <span>
                                                                {creditCard?.nameOnCard}
                                                                <br />
                                                            </span>
                                                        )}
                                                        <span className="dialog-icon">
                                                            <em className="las la-credit-card inline-icon"></em> {creditCard?.cardNumber}
                                                            <br />
                                                        </span>
                                                        {creditCard?.expDateMo && creditCard?.expDateYr && (
                                                            <span>
                                                                Exp. {[creditCard?.expDateMo, creditCard?.expDateYr].join("/")}
                                                                <br />
                                                            </span>
                                                        )}
                                                        {creditCard?.billingZip}
                                                    </p>
                                                ) : (
                                                    <div className="msg-generic msg-small margin-top-xs">
                                                        <RenderIcons iconName="info-circle" />
                                                        There is no Payment Profile
                                                        <br />
                                                        associated with your account.
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <span
                                                    className="default_link"
                                                    onClick={(e) => {
                                                        showBillingInformation(e);
                                                        window.addToDataLayer({ event: "Protection Plan - Billing Info" });
                                                    }}
                                                >
                                                    <a href="javascript:void(0)" className="default_link">
                                                        {creditCard?.cardNumber ? "Update" : "Add"}
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {!creditCard?.cardNumber && selectedPackage?.ActionButtonText?.toLowerCase() != "cancel" && (
                                        <div className="data-value">
                                            <input
                                                type="text"
                                                name="cardNumber"
                                                id="label-payment-card-number"
                                                defaultValue={creditCard?.cardNumber}
                                                ref={register({ required: true })}
                                                style={{ opacity: 0, height: 0, width: 0, float: "left" }}
                                            />
                                            {errors["cardNumber"] && errors["cardNumber"].type === "required" && (
                                                <span className="form-error">Payment information is required</span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {selectedPackage?.ActionButtonText?.toLowerCase() != "cancel" && (
                        <React.Fragment>
                            <div className="form-row data-grid has-lines row-height-sm">
                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="label-monthly-charge">
                                                <strong>Price</strong>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value">
                                                ${Number(selectedPackage?.Price)?.toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div className="form-row data-grid row-height-sm">
                                <fieldset className="form-row inline">
                                    <div className="row data-row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="label-todays-charge">
                                                <h4 className="status-good">{getBillingAmountLabel()}</h4>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value">
                                                <div className="row between-xs">
                                                    <div className="col-xs col-no-gutter flex-grow-null">
                                                        <h4 className="status-good">${Number(selectedPackage?.["upgrade-cost"])?.toFixed(2)}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div className="msg-generic">
                                <div className="form-row data-grid">
                                    <div className="form-input">
                                        <label className="form-checkbox-label" htmlFor="isAgreed">
                                            <input type="checkbox" name="isAgreed" id="isAgreed" ref={register({ required: true })} />
                                            <span className="form-checkbox-label-text">
                                                I agree to the
                                                <span
                                                    className="default_link"
                                                    onClick={() => {
                                                        handleTncDialog("show");
                                                        window.addToDataLayer({ event: "Protection Plan - Show TNC" });
                                                    }}
                                                >
                                                    &nbsp;
                                                    <a href="javascript:void(0)" className="default_link">
                                                        Terms of Use
                                                    </a>
                                                </span>
                                                <p>
                                                    <br />I understand that I will be billed ${Number(selectedPackage?.Price).toFixed(2)}
                                                    &nbsp;each {selectedPackage["billing-cycle"]?.toLowerCase() == "yearly" ? "year" : "month"} until this
                                                    membership is cancelled. If canceled, my membership will end immediately and I will not be billed further. All
                                                    payments are non-refundable.
                                                </p>
                                                <p>
                                                    By clicking upgrade, your credit card will be billed today and will recur{" "}
                                                    {selectedPackage["billing-cycle"]?.toLowerCase() == "yearly" ? "yearly" : "monthly"}.
                                                </p>
                                            </span>

                                            {errors["isAgreed"] && errors["isAgreed"].type === "required" && (
                                                <span className="form-error">You must agree to the terms of use.</span>
                                            )}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}

                    {selectedPackage?.ActionButtonText?.toLowerCase() == "cancel" && (
                        <div className="msg-generic">
                            <p>We are sorry to see you leave us.</p>
                            <p>
                                If you would like to cancel your membership including all members on your account, please click on Cancel Plan button. You will
                                receive an email confirming your cancelation.
                            </p>
                            <p>
                                We have other protection plans available that you may be interested in. Please call us at{" "}
                                <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a> to learn more.
                            </p>
                        </div>
                    )}
                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                id="btn-submit-purchase"
                                disabled={loading}
                                onClick={() => window.addToDataLayer({ event: "Protection Plan - Submit " + selectedPackage?.ActionButtonText?.toUpperCase() })}
                            >
                                <span className="btn-text">{submitButtonLabel()}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            {showBillingInfoDialog && (
                <DialogComponent
                    dialogId="protection-plan-billing-information-dialog"
                    title="Billing Information"
                    datalayerEvent="Protection Plan - Close billing info"
                    closeDialog={() => {
                        handleBillingCloseDialog("close");
                    }}
                >
                    <IDFProtectionPlanBillingInfo
                        dialogId="protection-plan-billing-information-dialog"
                        closeDialog={() => {
                            handleBillingCloseDialog("close");
                        }}
                        creditCard={creditCard}
                    ></IDFProtectionPlanBillingInfo>
                </DialogComponent>
            )}

            {tncDialog && (
                <DialogComponent
                    dialogId="protection-plan-tnc-dialog"
                    title="Terms and Conditions"
                    datalayerEvent="Protection Plan - Close TNC"
                    closeDialog={() => handleTncDialog("close")}
                >
                    <IDFProtectionPlanTermsAndCondition
                        dialogId="protection-plan-tnc-dialog"
                        closeDialog={() => handleTncDialog("close")}
                        packageIndex={props.packageIndex}
                    ></IDFProtectionPlanTermsAndCondition>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};
export default IDFProtectionPlanUpgradePackage;
